import { t } from 'i18next';

const NOTIFICATION_TYPES = {
  ALERT: 'alert',
  UPDATES: 'updates',
  SOLVED: 'solved',
  NEWS: 'news',
  REMINDER: 'reminder',
} as const;

type TranslatableNotificationType =
  (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

const DEFAULT_TYPE: TranslatableNotificationType = NOTIFICATION_TYPES.ALERT;

export const CATEGORY_TO_TYPE: Partial<
  Record<number, TranslatableNotificationType>
> = {
  1: NOTIFICATION_TYPES.ALERT,
  2: NOTIFICATION_TYPES.UPDATES,
  3: NOTIFICATION_TYPES.SOLVED,
  4: NOTIFICATION_TYPES.NEWS,
  5: NOTIFICATION_TYPES.REMINDER,
};

export const getNotificationType = (
  category: number,
): { type: TranslatableNotificationType; translation: string } => {
  const type = CATEGORY_TO_TYPE[category] ?? DEFAULT_TYPE;
  /**
   * t('notifications.card.type.alert')
   * t('notifications.card.type.updates')
   * t('notifications.card.type.solved')
   * t('notifications.card.type.news')
   * t('notifications.card.type.reminder')
   *
   */

  return {
    type,
    translation: t(`notifications.card.type.${type}`),
  };
};
